/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Portugal)
export default {
	'project-pages.connect-space-dialog.connection-error': 'Falha da ligação.',
	'project-pages.connect-space-dialog.connection-retry': 'Tentar novamente',
	'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
		'Este projeto tem de estar ligado a um espaço antes de o utilizador poder criar uma página. Selecione um espaço para ligar a este projeto.',
	'project-pages.connect-space-dialog.error-icon': 'Erro:',
	'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
	'project-pages.connect-space-dialog.footer.connect-space': 'Ligar',
	'project-pages.connect-space.description':
		'Os espaços são como pastas, pode utilizá-los para criar, organizar e colaborar em todo o conteúdo relacionado com o seu projeto.',
	'project-pages.create-space-dialog.connection-error': 'Falha da ligação.',
	'project-pages.create-space-dialog.connection-retry': 'Tentar novamente',
	'project-pages.create-space-dialog.content.empty-name': 'Atribua um nome ao seu espaço.',
	'project-pages.create-space-dialog.content.invalid-name':
		'Os nomes de espaço têm de incluir pelo menos uma letra ou número.',
	'project-pages.create-space-dialog.content.placeholder': 'Introduza um nome de espaço',
	'project-pages.create-space-dialog.creation-error': 'Falha ao criar o espaço.',
	'project-pages.create-space-dialog.error-icon': 'Erro:',
	'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
	'project-pages.create-space-dialog.footer.create-space': 'Criar',
	'project-pages.create-space-dialog.header.title': 'Criar novo espaço do Confluence',
	'project-pages.default-contextual-message':
		'Crie, partilhe e colabore nos documentos do seu projeto num só local, com as páginas Confluence.',
	'project-pages.default-reactivate-CTA': 'Reativar o Confluence',
	'project-pages.default-trial-CTA': 'Experimente o Confluence grátis durante 30 dias',
	'project-pages.generic-error.button.reload': 'Recarregar página',
	'project-pages.generic-error.description': 'Ocorreu um erro. Tente novamente mais tarde.',
	'project-pages.generic-error.heading': 'Bem, isto é constrangedor...',
};
